module.exports = __webpack_public_path__ + "img/what2.c261b23d.png";